import React from "react";
import { Link } from "react-router-dom";

const Cancellation = () => {
  return (
    <>

      <div>
        <section className="bg-gray-100/50 py-20 lg:py-28 max-md:pt-[120px]">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

            {/* Section Header */}
            <div className="text-center">

              {/* Badge */}
              <div className="inline-flex items-center gap-2 rounded-full border border-[#1AAD9D50] bg-[#F4FFFE] px-4 py-2"  data-aos="fade-down">
                <span className="relative flex h-2 w-2">

                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#1AAD9D] opacity-75" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-[#1AAD9D]" />
                </span>
                <span className="text-sm font-medium text-[#1AAD9D]">
                  Cancellation Rules
                </span>
              </div>
              <h2 className="mt-4 font-display text-3xl font-bold text-gray-900 lg:text-4xl" data-aos="fade-up" data-aos-delay={100}>
                Cancellation Policy
              </h2>
            </div>

            <div className="theme-container mx-auto mt-[40px]" data-aos="fade-up" data-aos-delay={200}>
              <div className="w-full">
                <div className="container">
                  <div className="services-details-items">
                    <div className="row">
                      <div className="col-xl-12 services-single-content">
                        <p>
                          We believe in helping our customers as much as possible and have therefore adopted a liberal cancellation policy. Under this policy:
                        </p>
                        <ul>
                          <li>
                            1.	Cancellations will be considered only if the request is made within 7 days of placing the order. However, the cancellation request may not be entertained if the order has already been communicated to the vendors/merchants and they have initiated the shipping process.
                          </li>
                          <li>
                            2.	We do not accept cancellation requests for orders that have already been initiated, are in transit, or have been completed. However, a refund or replacement may be provided if the customer can establish that the quality of the product or service delivered is unsatisfactory.
                          </li>
                          <li>
                            3.	In case of improper delivery of services or inaccurate results, please report the issue to our Customer Service team. The request will be entertained once the healthcare provider has reviewed and verified the issue. This should be reported within 7 days of receipt of the product or service.
                          </li>
                          <li>
                            4.	If you feel that the product or service received is not as promised or does not meet your expectations, you must notify our Customer Service team within 7 days of receiving the product or service. After reviewing your complaint, the team will take an appropriate decision.
                          </li>
                          <li>
                            5.	In case any refund is approved, it will take 6–8 days for the amount to be processed and credited to the customer.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>


    </>
  );
};

export default Cancellation;
